import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

/**
 * NativeDateAdapter.parse() ignora MAT_DATE_LOCALE: usa Date.parse(), que
 * interpreta cualquier texto tecleado como MM/DD (formato US) sin importar
 * el locale configurado. Por eso al escribir manualmente "07/09/2026"
 * (7 de septiembre) el datepicker lo reinterpreta como 9 de julio. Al elegir
 * la fecha desde el calendario no pasa por parse(), por eso ahí sí funciona.
 *
 * Con MAT_DATE_LOCALE='es' además cambia el padding: Intl.DateTimeFormat
 * con locale 'es' no rellena con ceros los formatos numéricos puros
 * (da "7/9/2026" en vez de "07/09/2026" como con 'en-GB'), lo que
 * desalinearía el valor mostrado respecto a lo que escribe la máscara.
 *
 * Esta clase sobreescribe parse() para interpretar siempre día/mes/año, y
 * format() para forzar dd/MM/yyyy con ceros en el input, dejando que el
 * locale siga controlando solo los nombres de mes/día del calendario.
 */
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {

    parse(value: any): Date | null {
        if (typeof value === 'number') {
            return new Date(value);
        }
        if (typeof value !== 'string' || !value.trim()) {
            return null;
        }

        const match = /^(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?$/.exec(value.trim());
        if (!match) {
            return null;
        }

        const dia = Number(match[1]);
        const mes = Number(match[2]) - 1;
        let anio = match[3] ? Number(match[3]) : new Date().getFullYear();
        if (match[3] && match[3].length === 2) {
            anio += 2000;
        }

        const fecha = new Date(anio, mes, dia);
        const esValida = fecha.getFullYear() === anio && fecha.getMonth() === mes && fecha.getDate() === dia;
        return esValida ? fecha : null;
    }

    format(date: Date, displayFormat: any): string {
        const esFormatoNumericoPuro = displayFormat
            && displayFormat.year === 'numeric'
            && displayFormat.month === 'numeric'
            && displayFormat.day === 'numeric';

        if (esFormatoNumericoPuro) {
            const dia = String(date.getDate()).padStart(2, '0');
            const mes = String(date.getMonth() + 1).padStart(2, '0');
            return `${dia}/${mes}/${date.getFullYear()}`;
        }

        return super.format(date, displayFormat);
    }
}
